import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';

import type { SharedProps } from 'reconnect-types/moduleFederation';

type EmptyStateProps = Pick<
  SharedProps['ClientListEmptyState'],
  'onAddNew' | 'onImport' | 'canCreateClients' | 'canImportClients'
>;

type Props = EmptyStateProps & {
  node: HTMLElement;
};

export const ClientListEmptyStateInitializer = ({
  node,
  onAddNew,
  onImport,
  canCreateClients,
  canImportClients,
}: Props): Initializer => {
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  return {
    destroy,
    render: (props?: Partial<EmptyStateProps>) => {
      destroy();
      ReactDOM.render(
        <Reconnect
          name="ClientListEmptyState"
          props={{
            onAddNew: props?.onAddNew ?? onAddNew,
            onImport: props?.onImport ?? onImport,
            canCreateClients: props?.canCreateClients ?? canCreateClients,
            canImportClients: props?.canImportClients ?? canImportClients,
          }}
        />,
        node,
      );
    },
  };
};
